import { useState } from "react";
import { subscribeNewsletter } from "../../services/news.service";

export default function NewsletterForm({ source = "research-page", eyebrow = "Research digest" }) {
  const [email, setEmail]   = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [msg, setMsg]       = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const data = await subscribeNewsletter(email.trim(), source);
      setMsg(data.message || "Subscribed!");
      setStatus("success");
    } catch (err) {
      setMsg(err.message || "Something went wrong. Please try again.");
      setStatus("error");
    }
  };

  return (
    <>
      {status === "success" ? (
        <div className="newsletter-success">
          <div className="newsletter-success-icon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <p className="newsletter-success-msg">{msg}</p>
        </div>
      ) : (
        <>
          <div className="newsletter-eyebrow-wrap">
            <div className="eyebrow-muted">{eyebrow}</div>
          </div>
          <h2 className="newsletter-title">Stay in the loop</h2>
          <p className="newsletter-sub">
            New notes every two weeks. No spam - unsubscribe whenever.
          </p>
          <form className="newsletter-form" onSubmit={submit}>
            <input
              type="email"
              required
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
              aria-invalid={status === "error"}
            />
            <button type="submit" disabled={status === "loading"} className="newsletter-submit">
              {status === "loading" ? "Subscribing…" : "Subscribe"}
            </button>
            {status === "error" && <p className="newsletter-error">{msg}</p>}
          </form>
        </>
      )}
    </>
  );
}
